var React = require('react');

function StackBlitz (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m0 192.157h96.126l-56 135.843 183.874-193.315h-96.567l55.559-134.685z"}));
}

StackBlitz.defaultProps = {"height":"328","viewBox":"0 0 224 328","width":"224"};

module.exports = StackBlitz;

StackBlitz.default = StackBlitz;
